<template>
  <div class="login-layout">
    <div class="login-container">


      <!--LOGIN-->
      <Card class="login-card">
        <div align="center" class="mb-30">
          <img src="/static/img/logo.png" alt="" style="width: 115px">
        </div>


        <div v-if="!choiceUrl">
          <h1 class="login-header">Регистрация в системе Light Kassa</h1>
          <div style="min-height: 200px;">

            <Form

              ref="formDataRegister"
              :model="formDataRegister"
              :rules="rules"

            >

              <!--STEP 1-->
              <div v-if="step_reg_1">
                <FormItem prop="username">
                  <Label>Введите номер телефона</Label>
                  <Input
                    type="text"
                    v-model="formDataRegister.username"
                    placeholder="Имя пользователя"
                    size="large"
                    v-mask="'+7(###) ###-##-##'"
                  >
                  </Input>
                </FormItem>

                <FormItem prop="email">
                  <Label>Введите e-mail:</Label>
                  <Input
                    type="email"
                    v-model="formDataRegister.email"
                    placeholder="e-mail"
                    size="large"
                  >
                  </Input>
                </FormItem>

                <Button
                  type="info"
                  @click="registerStep_1()"
                  size="large"
                  :disabled="!validForm_step_1"
                >
                  Далее
                </Button>

                <div class="options-box">
                  <router-link to="/login" class="options-box__item">Уже зарегистрированы? Войти в систему.</router-link>
                </div>

                <Spin size="large" fix v-if="loading"></Spin>
              </div>


              <!--STEP 2-->
              <div v-if="step_reg_2">
                <FormItem prop="password">
                  <label>Придумайте пароль</label>

                  <div class="pass-container">
                    <Input
                      :type="pass_1"
                      minlength="4"
                      class="border_30"
                      v-model="formDataRegister.password"
                      placeholder="Новый пароль"
                      size="large"

                    >
                    </Input>
                    <span class="btn-show-pass" @click="changePassType(1)">
                    <Icon color="#acacac" v-if="pass_1 === 'password'" type="ios-eye" />
                    <Icon color="#acacac" v-if="pass_1 === 'text'" type="ios-eye-off" />
                  </span>
                  </div>




                </FormItem>

                <FormItem prop="password_check">
                  <label>Подтвердите пароль</label>
                  <div class="pass-container">
                    <Input
                      :type="pass_2"
                      minlength="4"
                      class="border_30"
                      v-model="formDataRegister.password_check"
                      placeholder="Подтвердите пароль"
                      size="large"
                    >
                    </Input>
                    <span class="btn-show-pass" @click="changePassType(2)">
                    <Icon color="#acacac" v-if="pass_2 === 'password'" type="ios-eye" />
                    <Icon color="#acacac" v-if="pass_2 === 'text'" type="ios-eye-off" />
                  </span>
                  </div>
                  <div class="ivu-form-item-error-tip" style="position: static" v-if="passwordWrong">Пароль должен совпадать</div>

                </FormItem>

                <FormItem prop="bin">
                  <label>БИН/ИИН:</label>
                  <Input
                    class="border_30"

                    v-model="formDataRegister.bin"
                    placeholder="************"
                    size="large"
                    v-mask="'############'"
                  >
                  </Input>
                </FormItem>

                <div class="d-flex">
                  <Button
                    style="margin-right: 24px"
                    type="success"
                    size="large"
                    @click="back_toStep_1()"
                  >
                    Назад
                  </Button>
                  <Button
                    style="margin-left: 24px"
                    type="info"
                    @click="registerStep_2()"
                    size="large"
                    :disabled="!validForm_step_2"
                  >
                    Далее
                  </Button>
                </div>

                <div class="options-box">
                  <router-link to="/login" class="options-box__item">Уже зарегистрированы? Войти в систему.</router-link>
                </div>

              </div>

              <div v-if="step_reg_3">
                <Label>Введите код из SMS-сообщения</Label>
                <Input
                  class="border_30"
                  type="text"
                  v-model="enterKey"
                  placeholder="****"
                  size="large"
                >
                </Input>

                <div class="timer-box">

                  <div class="d-flex">
                    <span>Осталось: </span>
                    <div style="padding: 0 3px">{{(time.h)?(time.h)+':':''}}{{(time.m > 9)?time.m:'0'+time.m}}:{{(time.s >
                      9)?time.s:'0'+time.s}}
                    </div>
                    <span> секунд</span>
                  </div>


                  <Button :disabled="!repeatCode" @click="registerStep_2()">отправить код повторно</Button>
                </div>

                <div class="d-flex">
                  <Button
                    style="margin-right: 24px"
                    type="success"
                    @click="back_toStep_2()"
                    size="large"
                  >
                    Назад
                  </Button>
                  <Button
                    style="margin-left: 24px"
                    type="info"
                    @click="registerStep_3()"
                    size="large"
                    :disabled="!enterKey"
                  >
                    Далее
                  </Button>
                </div>




                <div class="options-box">
                  <router-link to="/login" class="options-box__item">Уже зарегистрированы? Войти в систему.</router-link>
                </div>

              </div>



              <div v-if="step_reg_4">

                <h3 class="text-center">Вы успешно зарегистрированы в системе!</h3>
                <p class="text-center">Нажмите, чтобы продолжить</p>

                <div class="d-flex justify-center">

                  <Button
                    type="info"
                    @click="login()"
                    size="large"
                  >
                    Войти
                  </Button>
                </div>



              </div>

            </Form>

          </div>
        </div>



        <div v-if="choiceUrl">
          <h1 class="login-header">Войти в систему</h1>

          <router-link to="/" class="enter-card">
            <Row class="d-flex align-center" gutter="24">
              <Col span="24" :sm="12"><h3>Панель администратора</h3></Col>
              <Col :sm="12">
                <img src="/static/img/enter_home.jpg" alt="">
              </Col>
            </Row>
          </router-link>
          <a :href="kassa_addr" class="enter-card">
            <Row class="d-flex align-center" gutter="24">
              <Col span="24" :sm="12"><h3>Касса</h3></Col>
              <Col :sm="12">
                <img src="/static/img/enter_kassa.jpg" alt="">
              </Col>
            </Row>
          </a>
        </div>


      </Card>
    </div>

  </div>
</template>

<script>
    import {server_addr, login_addr, kassa_addr} from "../../http";
    import {mask} from "vue-the-mask";

    export default {
        name: "register",
        directives: {
            mask
        },
        data() {
            return {
                validForm_step_1: false,
                validForm_step_2: false,

                choiceUrl: false,

                step_reg_1: true,
                step_reg_2: false,
                step_reg_3: false,
                step_reg_4: false,

                formDataRegister: {
                    username: "+7",
                    email: "",
                    password: '',
                    password_check: '',
                    bin: '',
                },

                enterKey: '',
                formatNum: null,

                rules: {
                    username: [
                        {
                            required: true,
                            message: "Пожалуйста, введите имя пользователя",
                            trigger: "blur"
                        },
                        {
                            type: "string",
                            min: 17,
                            message: "Недостаточно символов",
                            trigger: "blur"
                        }
                    ],
                    email: [
                        {
                            required: true,
                            message: "Пожалуйста, введите email",
                            trigger: "blur"
                        },
                        {
                            type: 'email', message: 'Неверный формат', trigger: 'blur'
                        }
                    ],
                    password: [
                        {
                            required: true,
                            message: "Пожалуйста, введите пароль",
                            trigger: "blur"
                        },
                        {
                            type: "string",
                            min: 5,
                            max: 30,
                            message: "Длина пароля от 5 до 30 символов",
                            trigger: "blur"
                        }
                    ],
                    password_check: [
                        {
                            required: true,
                            message: "Пожалуйста, введите пароль",
                            trigger: "blur"
                        },
                        {
                            type: "string",
                            min: 5,
                            max: 30,
                            message: "Длина пароля от 5 до 30 символов",
                            trigger: "blur"
                        }
                    ],
                    bin: [
                        {
                            required: true,
                            min: 12,
                            max: 12,
                            message: "БИН/ИИН должен содержать 12 цифр",
                            trigger: "blur"
                        },
                    ]
                },

                pass_1: 'password',
                pass_2: 'password',

                passwordWrong: false,

                repeatCode: false,
                time: {m: 1, s: 59, ms: 0},
                timeOn: true,
                count: null,

                loading: false,

                admin: {
                    email: null,
                    firstName: 'Пользователь',
                    lastName: 'Новый',
                    password: null,
                    userId: null
                },

                organization: {
                    name: "Организация",
                    address: "Астана",
                    vatSeries: "",
                    vatNumber: "",
                    programmingPin: "0000",
                    taxationType: "100",
                    vatPayer: false,
                    taxes: [
                        {
                            "taxType": "100",
                            "taxRate": 12
                        }
                    ],
                    economicClassifier: "47191",
                    legalForm: "20",
                    region: "71",
                    utm: "",
                    itn: ''
                },


            };
        },
        watch: {
            "formDataRegister.username": function (val, oldVal) {
                this.isValidForm_step_1();
            },
            "formDataRegister.email": function (val, oldVal) {
                this.isValidForm_step_1();
            },
            "formDataRegister.password": function (val, oldVal) {
                this.isValidForm_step_2();
            },
            "formDataRegister.password_check": function (val, oldVal) {
                this.isValidForm_step_2();
            },
            "formDataRegister.bin": function (val, oldVal) {
                this.isValidForm_step_2();
            }
        },
        computed: {
            kassa_addr() {
                return kassa_addr;
            },
            username() {
                return this.formDataRegister.username.replace(/^\+7/, "").replace(/\D/g, "");
            },
            password() {
                return this.formDataRegister.password;
            },
            handledData() {
                return {
                    username: this.username,
                    password: this.password,
                    grant_type: "password"
                };
            }
        },

        methods: {
            ping: function () {
                if (this.timeOn) {
                    if (++this.time.ms > 9) {
                        this.time.ms = 0;
                        this.time.s--;
                    }
                    if (this.time.s < 0) {
                        this.time.s = 59;
                        this.time.m--;
                    }
                    if (this.time.m === 0 && this.time.s === 0) {
                        this.timeOn = false;
                        this.repeatCode = true;
                        clearTimeout(this.count);
                    }
                }
            },


            isValidForm_step_1() {
                this.$refs.formDataRegister.validate(valid => {
                    this.validForm_step_1 = valid;
                });
            },
            isValidForm_step_2() {
                this.$refs.formDataRegister.validate(valid => {
                    if (this.formDataRegister.password === this.formDataRegister.password_check) {
                        this.validForm_step_2 = valid;
                        this.passwordWrong = false;
                    } else {
                        this.passwordWrong = true;
                        this.validForm_step_2 = false;
                    }
                });
            },

            registerStep_1() {
                this.loading = true;

                let num = this.formDataRegister.username.split('');
                this.formatNum = num[3] + num[4] + num[5] + num[8] + num[9] + num[10] + num[12] + num[13] + num[15] + num[16];

                const url = login_addr + '/wcadmin/v1/checkExistence?userId=' + this.formatNum;
                this.checkLeads(num);
                this.$http
                    .get(url)
                    .then(response => {
                        this.step_reg_1 = false;
                        this.step_reg_2 = true;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
                    // .catch(error => {
                    //     this.$Notice.open({
                    //         title: 'Ошибка',
                    //         desc: error.response.data.userMessage[0].text
                    //     });
                    //
                    // })
            },


            checkLeads() {
                let phone = this.formDataRegister.username.replace(/[-()\s]/g, "");

                const url = login_addr + '/reports/v1/leads';
                this.$http
                    .post(url, {
                        "phone": phone,
                        "email": this.formDataRegister.email
                    })
                    .catch(error => {
                        console.log(error)

                    });

            },


            registerStep_2() {
                this.loading = true;
                // this.step_reg_2 = false;
                // this.step_reg_3 = true;

                const url = login_addr + '/wcadmin/v1/checkExistence?itn=' + this.formDataRegister.bin;
                this.$http
                    .get(url)
                    .then(response => {
                        this.checkEgr();

                    })
                    .finally(() => {
                        this.loading = false;
                    })

            },


            checkEgr() {
                const url = 'https://egr.lkassa.kz/customer/' + this.formDataRegister.bin;

                this.$http({
                    url: url,
                    // headers: {
                    //     'Access-Control-Allow-Origin': '*',
                    //     'Content-Type': 'application/json'
                    // },
                    method: 'GET',
                })
                    .then(response => {

                        this.organization.name = response.data.obj.name;

                        this.organization.economicClassifier = response.data.obj.okedCode;
                        this.organization.address  = response.data.obj.katoAddress;

                        if(response.data.obj.ip === true) {
                            this.organization.legalForm = '10';
                        }


                        let name = response.data.obj.fio.split(' ');

                        this.admin.firstName = name[0];
                        this.admin.middleName = name[2];
                        this.admin.lastName = name[1]

                        this.checkCode();
                    })
                    .finally(() => {
                        this.secretMessages();

                        this.step_reg_2 = false;
                        this.step_reg_3 = true;
                        this.time = {m: 1, s: 59, ms: 0};
                        this.repeatCode = false;
                        this.timeOn = true;
                        this.count = setInterval(this.ping, 100);

                        this.admin.email = this.formDataRegister.email;
                        this.admin.password = this.formDataRegister.password;
                        this.admin.userId = this.formatNum;
                        this.organization.itn = this.formDataRegister.bin;



                        this.loading = false;
                    })
            },

            checkCode() {
                const url = 'https://api.lkassa.kz/wcdim/v1/dimensions/REGIONS/items';
                this.$http(url)
                    .then(response => {
                        let code = response.data;
                        let address = JSON.stringify(this.organization.address).toLowerCase();

                        code.forEach(item => {
                            let name = item.name.toLowerCase();

                            if(address.includes(name + ',')) {
                              this.organization.region = item.code;
                            }


                        })

                    })
            },

            secretMessages() {
                const url = login_addr + '/wcsms/v1/secretMessages';
                this.$http
                    .post(url, {
                        "name": "Пользователь",
                        "phone": this.formatNum,
                        "surname": " "
                    })
                    .then(response => {

                    })
            },

            registerStep_3() {
                const url = login_addr + '/wcadmin/v1/orgWithAdmin';

                this.$http
                    .post(url, {
                        admin: this.admin,
                        organization: this.organization,
                        secret: this.enterKey

                    })
                    .then(response => {
                        this.step_reg_4 = true;
                        this.step_reg_3 = false;

                        // this.$Notice.open({
                        //     title: 'Уведомление',
                        //     desc: 'Вы успешно зарегистрированы!'
                        // });

                        // this.login();

                       // this.$router.push({name: "login"})
                    })
                    .finally(() => {

                        this.loading = false;
                    })
                    .catch(error => {
                    })
            },

            back_toStep_1() {
                this.step_reg_1 = true;
                this.step_reg_2 = false;
            },
            back_toStep_2() {
                this.step_reg_2 = true;
                this.step_reg_3 = false;
                clearTimeout(this.count);
            },

            changePassType(num) {
                if (num === 1) {
                    if(this.pass_1 === 'password') {
                        this.pass_1 = 'text'
                    }

                    else {
                        this.pass_1 = 'password'
                    }
                }
                if (num === 2) {
                    if(this.pass_2 === 'password') {
                        this.pass_2 = 'text'
                    }
                    else {
                        this.pass_2 = 'password'
                    }
                }

            },

            login: function () {
                this.loading = true;
                this.$store
                    .dispatch("login", {vm: this, data: this.handledData})
                    .then(() => {
                        this.loading = false;
                        // this.$router.push({ name: "home" });
                        const url = server_addr + '/api/v1/current_user/';
                        this.$http
                            .get(url)
                            .then(result => {
                                let data = result.data;
                                if (data.role === 'cashier' ) {
                                    window.location.href = kassa_addr
                                }
                                if (data.role === 'storekeeper'  ) this.$router.push({ name: "home" });
                                if (data.role === 'owner'  ) this.choiceUrl = true;
                            });
                    })
                    .catch(error => {
                        if (error.response.status === 400) {
                            // this.$Message.error("Неверное имя пользователя или пароль");
                            // this.$Message.error("Для работы с Товароучетной системой обратитесь в поддержку Light Kassa");
                          this.$Message.error("Проверьте корректность ввода логина или пароля. В случае повторной ошибки обратитесь в чат поддержки Light Kassa (правый нижний угол)");
                        } else {
                            this.$Message.error("Ошибка");
                        }
                        console.error(error);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        }
    };
</script>

<style scoped>
  .login-layout {
    width: 100%;
    margin: 0 auto;
    padding: 0;
    box-sizing: border-box;
    background-color: #ebebeb;
  }

  .login-container {
    background: url("/static/img/bg-login.d56f2ef7.png") right center;
    background-size: cover;
    width: 100%;
    min-height: 100vh;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 15px;
    margin: 0;
    box-sizing: border-box;

  }

  .login-header {
    text-align: center;
    margin-bottom: 30px;
  }

  .login-card {
    width: 600px;
    background: #fff;
    border-radius: 25px;
    position: relative;
    padding: 20px;
    margin-left: 10%;
  }

  label.ivu-form-item-label, label {
    color: #acacac;
    font-size: 15px;
    margin-bottom: 5px;
    display: block;
  }

  button {
    width: 300px;
    margin: 40px auto 24px auto;
    display: block;
    border-radius: 24px;
  }

  .timer-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 12px;
    color: #acacac;
  }

  .timer-box button {
    width: auto;
    margin: 0;
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 5px;
    color: #5087DE;
    text-decoration: underline;
    border-radius: 0;
  }

  .timer-box button[disabled="disabled"] {
    color: #acacac;
  }


  .options-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .options-box .options-box__item {
    padding: 0 12px;
    color: #5087DE;
    text-decoration: underline;
    font-weight: 600;
  }

  .options-box .options-box__item:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  .options-box .options-box__item:nth-child(2) {
    border-left: 1px solid #5087DE;
  }


  .pass-container {
    position: relative;
  }

  .pass-container .btn-show-pass {
    position: absolute;
    z-index: 5;
    right: 0;
    width: 48px;
    height: 100%;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pass-container .btn-show-pass:hover {
    cursor: pointer;
  }


  .enter-card {
    border-radius: 25px;
    text-transform: uppercase;
    margin-bottom: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
    display: block;
    padding: 20px;
  }

  .enter-card:hover {
    background: #5087DE;
  }

  .enter-card:hover h3 {
    color: #ffffff;
  }

  .enter-card img {
    max-width: 100%;
  }



  @media screen and (max-width: 767px) {
    .login-card {
      width: 90%;
      margin: 0 auto;
    }
  }

  @media screen and (max-width: 400px) {
    .login-card {
      width: 95%;
      padding: 12px;
    }

  }

</style>

<style>
  .login-layout .ivu-input-group-prepend {
    background-color: transparent;
    border: none;
  }

  .login-layout .ivu-input-group-with-prepend .ivu-input {
    border-top-left-radius: 18px;
    border-bottom-left-radius: 18px;
  }


  @media screen and (max-width: 400px) {

    .ivu-form-item-content .ivu-form-item-error-tip {
      font-size: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/apps/login/register.vue